import { useSelector } from 'react-redux';
import { resolveClientApiCopy } from './clientApiCopy';

/**
 * Returns the OLB copy bundle for the loaded form's locale
 * (`formConfig.localeCode`), resolving to English when absent/unknown.
 */
const useClientApiCopy = () => {
  const localeCode = useSelector((store) => store.formConfig?.localeCode);
  return resolveClientApiCopy(localeCode);
};

export default useClientApiCopy;
